<template>
  <v-container>
    <v-card>
      <v-toolbar flat color="grey lighten-2">
        <v-toolbar-title>Scheduled Operations</v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-btn-toggle
          v-model="typeFilter"
          @change="filterScheduledOperationList"
        >
          <v-btn value="ONCE">
            Once
          </v-btn>
          <v-btn value="PERIODIC">
            Periodic
          </v-btn>
        </v-btn-toggle>
        <v-spacer></v-spacer>
        <v-btn-toggle
          v-model="statusFilter"
          @change="filterScheduledOperationList"
        >
          <v-btn value="ENABLED">
            Enabled
          </v-btn>
          <v-btn value="DELETED">
            Deleted
          </v-btn>
        </v-btn-toggle>
      </v-toolbar>
      <div
        v-if="$apollo.queries.listScheduledOperationsOnShowcase.loading"
        class="d-flex justify-center mb-6"
      >
        <v-progress-circular indeterminate color="grey"></v-progress-circular>
      </div>

      <div v-else-if="listScheduledOperationsOnShowcaseErrors">
        <v-alert dense outlined type="error">
          {{ listScheduledOperationsOnShowcaseErrors }}
        </v-alert>
      </div>
      <div v-else-if="listScheduledOperationsOnShowcase">
        <v-data-table
          :headers="headers"
          :items="listScheduledOperationsOnShowcase.scheduledOperations || []"
          :sort-by="['scheduleCreationDate']"
          multi-sort
          :sort-desc="[true, true]"
          no-data-text="No operations found."
          footer-props.items-per-page-text="Elements per site"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.scheduleStatus }}</td>
              <td>{{ item.userId }}</td>
              <td>{{ transformCronExpression(item.scheduleExpression) }}</td>
              <td>{{ item.scheduleType }}</td>
              <td>{{ item.scheduleCreationDate }}</td>
              <td>
                <v-icon
                  v-if="item.scheduleStatus === 'ENABLED'"
                  @click="showDeleteForm(item)"
                  color="red"
                  >mdi-delete</v-icon
                >
                <v-icon
                  v-if="item.scheduleStatus === 'DELETED'"
                  color="grey"
                  small
                  >mdi-block-helper</v-icon
                >
              </td>
            </tr>
          </template>

          <template slot="pageText" slot-scope="item">
            {{ item.pageStart }} von {{ item.pageStop }}
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="deleteDialogForm" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          Delete scheduled operation?
        </v-card-title>
        <v-card-text>{{ deleteMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" @click="deleteScheduledOperation">
            Delete
          </v-btn>
          <v-btn color="grey" @click="deleteDialogForm = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  DELETE_SCHEDULED_OPERATION,
  LIST_SCHEDULED_OPERATIONS
} from '../../constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import cronParser from 'aws-cron-parser'

export default {
  name: 'ShowcaseOperationsList',
  data: () => ({
    statusFilter: 'ENABLED',
    typeFilter: null,
    headers: [
      { text: 'Name', value: 'name', sortable: true },
      { text: 'Status', value: 'scheduleStatus', sortable: true },
      { text: 'User', value: 'userId', sortable: true },
      {
        text: 'Schedule Expression',
        value: 'scheduleExpression',
        sortable: false
      },
      { text: 'Schedule Type', value: 'scheduleType', sortable: true },
      { text: 'Creation Date', value: 'scheduleCreationDate', sortable: true },
      { text: 'Delete', value: 'delete', sortable: false }
    ],
    listScheduledOperationsOnShowcase: [],
    listScheduledOperationsOnShowcaseErrors: null,
    deleteDialogForm: false,
    selectedScheduledOperation: null,
    deleteMessage: ''
  }),
  props: ['showcase'],
  apollo: {
    $client: DOMAIN_NAME,
    listScheduledOperationsOnShowcase: {
      query: LIST_SCHEDULED_OPERATIONS,
      fetchPolicy: 'network-only',
      variables() {
        return {
          showcaseId: this.showcase.showcaseId,
          scheduleStatusFilter: this.statusFilter
        }
      },
      skip() {
        return !this.showcase
      },
      error(error) {
        this.listScheduledOperationsOnShowcaseErrors = JSON.stringify(
          error.message
        )
      }
    }
  },
  methods: {
    statusIcon: function(status) {
      return status ? status.color : 'black'
    },
    transformCronExpression: function(cronExpression) {
      let cronExpressionString = cronExpression
        .substr(5)
        .substr(0, cronExpression.length - 6)
      let cron = cronParser.parse(cronExpressionString)
      if (cronParser.prev(cron, new Date()) !== null) {
        return cronParser.prev(cron, new Date()).toString()
      } else {
        return cronParser.next(cron, new Date()).toLocaleString()
      }
    },
    filterScheduledOperationList() {
      this.$apolloProvider.clients[DOMAIN_NAME].query({
        query: LIST_SCHEDULED_OPERATIONS,
        variables: {
          showcaseId: this.showcase.showcaseId,
          scheduleStatusFilter: this.statusFilter,
          scheduleTypeFilter: this.typeFilter
        },
        fetchPolicy: 'network-only'
      }).then(response => {
        this.listScheduledOperationsOnShowcase =
          response.data.listScheduledOperationsOnShowcase
      })
    },
    showDeleteForm(item) {
      this.deleteDialogForm = true
      this.selectedScheduledOperation = item
    },
    deleteScheduledOperation() {
      this.deleteMessage = 'Deleting scheduled operation...'
      this.$apolloProvider.clients[DOMAIN_NAME].mutate({
        mutation: DELETE_SCHEDULED_OPERATION,
        variables: {
          showcaseId: this.selectedScheduledOperation.showcaseId,
          scheduleId: this.selectedScheduledOperation.scheduleId
        }
      })
        .then(response => {
          this.deleteMessage = 'Scheduled operation deleted'
          this.filterScheduledOperationList()
        })
        .catch(err => {
          this.deleteMessage = err
        })
    }
  }
}
</script>

<style scoped></style>
